// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"90":"wix-bookings-services-preferences-modal","599":"Gallery","965":"Scheduling"}[chunkId] || chunkId) + ".chunk.min.css";
};